function menu() {
	let button_show_menu = document.querySelector('.show_menu_mobile');
	//let button_close_menu = document.querySelector('.close_menu_mobile');
	button_show_menu.addEventListener('click', function(e){
		e.preventDefault();
		toggler();
	});
	/*button_close_menu.addEventListener('click', function(e){
		e.preventDefault();
		toggler();
	});*/

}

function toggler() {
	let set_menu_devices = document.querySelector('header.set_menu_devices');
	let body = document.querySelector('body');
	let height = fixedHeaderMobile();
	set_menu_devices.classList.toggle('get_menu_mobile');
	//set_menu_devices.classList.add('bg-tap-header');
	set_menu_devices.style.top = height+'px';
	body.classList.toggle('body_search_oh');
}

function fixedHeaderMobile() {
    let mobile_header = document.querySelector('.section_header_top');

	return window.innerWidth < 991 ? mobile_header.offsetHeight : 0;
}

/*function closeMenuFromLink() {
	let menus = document.querySelectorAll('header .navigation nav.nav ul.menu li.menu-item a');
	Array.prototype.slice.call(menus)
		.forEach(function (menu) {
			menu.addEventListener('click', function(e){
				let url = menu.getAttribute('href');
				let currentUrl = window.location.href;
				let baseUrl = window.location.protocol + "//" + window.location.host + "/";
				let baseUrlObtain = currentUrl.split('#')[0];
				let urlDestination = baseUrl + "/"+ url
				/!**
				 * si la base url y la url obtenida en el estado actual son distintos en ese caso se redirecciona al home
				 *!/
				if (baseUrl !== baseUrlObtain) {
					window.location.href = urlDestination;
				} else {
					/!**
					 * Eliminamos el hash cuando sea ancla en el home
					 *!/
					if (currentUrl.includes('#')) {
						let newUrl = currentUrl.split('#')[0];
						history.replaceState(null, null, newUrl);
					}
				}
				toggler();
			});
		})
}*/

export { menu, toggler };
